// Stripe Payment Links for the /cn sponsorship tiers.
//
// IMPORTANT — these are ONE-TIME ANNUAL payments, not subscriptions. WeChat Pay / Alipay via Stripe
// are single-use payment methods (they can't auto-renew), and Chinese forwarders pay that way — so we
// sell an annual prepay the buyer pays once via WeChat Pay / Alipay / card. Monthly price is display-only.
//
// TO GO LIVE: in the Stripe dashboard (Wemelogistics Ltd) create one Payment Link per tier —
//   • Currency CNY, one-time, amount = the annual figure below
//   • Payment methods: enable Card + Alipay + WeChat Pay (Settings → Payment methods first)
//   • After-payment: redirect to https://freightratesmcp.com/cn?paid=1 (optional)
// then paste each link URL below. Empty string = button falls back to the contact form.

export interface CnTier {
  key: 'base' | 'featured' | 'flagship'
  annualCny: number // one-time annual charge
  payUrl: string // Stripe Payment Link (empty until created)
}

export const CN_TIERS: Record<CnTier['key'], CnTier> = {
  base: { key: 'base', annualCny: 19800, payUrl: 'https://buy.stripe.com/eVqeVc1yegExcLwasFbjW02' },
  featured: {
    key: 'featured',
    annualCny: 49800,
    payUrl: 'https://buy.stripe.com/28E14m0ua3RLbHsgR3bjW03',
  },
  flagship: {
    key: 'flagship',
    annualCny: 88000,
    payUrl: 'https://buy.stripe.com/cNi5kC5Ou5ZT12O7gtbjW04',
  },
}

export const cnyAnnual = (key: CnTier['key']) => `¥${CN_TIERS[key].annualCny.toLocaleString('en-US')}`
export const payUrl = (key: CnTier['key']) => CN_TIERS[key].payUrl
